<div class="top">
  <app-upgrader-bet-section></app-upgrader-bet-section>
  <app-upgrader-main class="main"></app-upgrader-main>
  <app-upgrader-selected-skins></app-upgrader-selected-skins>
</div>
<app-upgrader-skins-selection />
